<div [ngSwitch]="activeAction">
    <div (click)="openContextMenu($event); showTooltip = false;" (mouseout)="showTooltip = true;">
        <div class="action__name" *ngSwitchDefault>-</div>
        <div class="action__name action__name__tooltip" id="{{activeAction + '_PLUS'}}" *ngSwitchCase="'INCREASE_PERCENT'"
            role="button" data-tooltip="Increase year amount by %" [class.hide__tooltip]="!showTooltip">+</div>
        <div class="action__name action__name__tooltip" id="{{activeAction + '_A'}}" *ngSwitchCase="'ANNUALIZE'"
            role="button" data-tooltip="The A button uses the annualized value of sales and applies it to the revenue."
            [class.hide__tooltip]="!showTooltip">
            A</div>
        <div class="action__name action__name__tooltip" id="{{activeAction + '_LY'}}" *ngSwitchCase="'LAST_YEAR'"
            data-tooltip="The LY button uses the prior year's value of sales and applies it to the revenue."
            [class.hide__tooltip]="!showTooltip">LY</div>
        <div class="action__name action__name__tooltip" id="{{activeAction + '_LPER'}}"
            *ngSwitchCase="'LAST_YEAR_PERCENT'"
            data-tooltip="The L% button uses the prior year's percentage of sales and applies it to the revenue."
            [class.hide__tooltip]="!showTooltip">L%
        </div>
        <div class="action__name action__name__tooltip" id="{{activeAction + '_HPER'}}" *ngSwitchCase="'HISTORICAL'"
            data-tooltip="The H% button uses the historical average percentage of sales and applies it to the revenue."
            [class.hide__tooltip]="!showTooltip">
            H%</div>
    </div>
</div>